import { Component, OnInit } from '@angular/core';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-invoice-backup',
  templateUrl: './invoice-backup.component.html',
  styleUrls: ['./invoice-backup.component.css']
})
export class InvoiceBackupComponent implements OnInit {

  public menu_item_id = '125';

  model = {
    'table_name': 'invoice', 'from_date': new Date(), 'to_date': new Date(), 'title': 'نسخ احتياطي للفواتير', 
    'title2': 'نسخ احتياطي للفواتير', 'title3': 'نسخ اختياطي للعمليات', 'title4': 'نسخ اختياطي للحسابات'
  };

  from_date;
  to_date;

  From_Date; To_Date; Invoice_Backup; Invoice_Item_Backup;
  Acct_Log_Backup; Account_List_Backup;
  Search_Msg; Success_Msg; Error_Msg; 

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public translate: TranslateService) { 
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Invoice_Backup').subscribe((res: string) => {
      this.Invoice_Backup = res;
    });
    this.model['title'] = this.Invoice_Backup;

    translate.get('Invoice_Item_Backup').subscribe((res: string) => {
      this.Invoice_Item_Backup = res;
    });
    this.model['title2'] = this.Invoice_Item_Backup;

    translate.get('Acct_Log_Backup').subscribe((res: string) => {
      this.Acct_Log_Backup = res;
    });
    this.model['title3'] = this.Acct_Log_Backup;

    translate.get('Account_List_Backup').subscribe((res: string) => {
      this.Account_List_Backup = res;
    });
    this.model['title4'] = this.Account_List_Backup;

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
  }

  ngOnInit() {
  }

  export() {
    if (this.model['from_date'] == undefined && this.model['to_date'] == undefined) {
      alert(this.Search_Msg);
      return;
    }

    if (this.model['from_date'] != undefined) 
      this.from_date = this.model['from_date'].getFullYear() + "-" + 
        (this.model['from_date'].getMonth() + 1) + "-" + this.model['from_date'].getDate() + ' 00:00:00';

    if (this.model['to_date'] != undefined) 
      this.to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + 
        "-" + this.model['to_date'].getDate() + ' 23:59:59';

    let query, obj;
    query = "SELECT * FROM `invoice` WHERE `invoice_date` BETWEEN '" + this.from_date + "' AND '" + this.to_date + "'";
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let invoice_list = data.data['list'];

        this.utils.exportToExcel(invoice_list, this.model.title, "json");
      });

    query = "SELECT * FROM `invoice_item` WHERE `invoice_date` BETWEEN '" + this.from_date + "' AND '" + this.to_date + "'";
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let invoice_item = data.data['list'];

        this.utils.exportToExcel(invoice_item, this.model.title2, "json");
      });

    query = "SELECT * FROM `acct_log` WHERE `log_date` BETWEEN '" + this.from_date + "' AND '" + this.to_date + "'";
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let acct_log = data.data['list'];

        this.utils.exportToExcel(acct_log, this.model.title3, "json");
      });

    query = "SELECT * FROM `sub_acct` WHERE `created_on` BETWEEN '" + this.from_date + "' AND '" + this.to_date + "'";
    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let sub_acct = data.data['list'];

        this.utils.exportToExcel(sub_acct, this.model.title4, "json");
      });
  }

}
